export class ClaimTypes {
  static readonly NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';
  static readonly EMAIL =
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
  static readonly NAME_IDENTIFIER = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
  static readonly FIRST_NAME = 'FirstName';
  static readonly SURNAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname';
  static readonly POSTAL_CODE = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/postalcode';
  static readonly PERMISSION = 'Permission';
  static readonly VEHICLE_PERMISSION = 'VehiclePermission';
  static readonly VEHICLE_IDENTIFICATION_NUMBER = 'Vehicle';
  static readonly TERMS_AND_CONDITIONS_ACCEPTED = 'TermsAndConditionsAccepted';
  static readonly ALLOW_PUSH_NOTIFICATIONS = 'AllowPushNotifications';
}

export class Permissions {
  static readonly ManageAllUsers = 'Manage All Users';
  static readonly ManageRoles = 'Manage Roles';
  static readonly ManageEmails = 'Manage Emails';
  static readonly InviteConsumerUser = 'Invite Consumer User';
  static readonly VehicleReadAccess = 'Vehicle Read Access';
  static readonly VehicleWriteAccess = 'Vehicle Write Access';
}
